// extracted by mini-css-extract-plugin
module.exports = {"price":"item_price_3gDUg"};